var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalAppeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0808105,
    width: 40,
    height: 40,
    rx: 10,
    fill: "#FFAC06",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0808 15.1667V29.3333M20.0808 29.3333H17.5808M20.0808 29.3333H22.5808",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5809 21.8333L25.4975 17.6667L23.4142 21.8333",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7475 21.8333L14.6641 17.6667L12.5808 21.8333",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4142 17.6667H14.2877C15.3406 17.6667 16.3621 17.2258 17.1843 16.4167C18.8777 14.75 21.284 14.75 22.9774 16.4167C23.7996 17.2258 24.8211 17.6667 25.874 17.6667H26.7475",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4975 25.1667C26.6264 25.1667 27.6095 24.4719 28.1202 23.4458C28.3958 22.8918 28.5336 22.6149 28.2821 22.2242C28.0305 21.8333 27.6141 21.8333 26.7814 21.8333H24.2136C23.3808 21.8333 22.9645 21.8333 22.7129 22.2242C22.4613 22.6149 22.5991 22.8918 22.8747 23.4458C23.3855 24.4719 24.3686 25.1667 25.4975 25.1667Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 25.1667C15.793 25.1667 16.7761 24.4719 17.2868 23.4458C17.5625 22.8918 17.7003 22.6149 17.4487 22.2242C17.1971 21.8333 16.7808 21.8333 15.9481 21.8333H13.3801C12.5474 21.8333 12.1311 21.8333 11.8795 22.2242C11.6279 22.6149 11.7658 22.8918 12.0414 23.4458C12.5521 24.4719 13.5352 25.1667 14.6641 25.1667Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3308 13.9167C21.3308 14.607 20.7711 15.1667 20.0808 15.1667C19.3905 15.1667 18.8308 14.607 18.8308 13.9167C18.8308 13.2263 19.3905 12.6667 20.0808 12.6667C20.7711 12.6667 21.3308 13.2263 21.3308 13.9167Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAppeal);
export default __webpack_public_path__ + "static/media/total-appeal.8f9e7c5b2e1f5359904c674610ef57f8.svg";
export { ForwardRef as ReactComponent };